import type { ApiV2OnClick } from '@dce-front/hodor-types/api/v2/common/dto/definitions';
import type { NavigationItemOnClick } from '@dce-front/hodor-types/modules/account_profile/definitions';

export const computeApiV2OnClickFromNavigationItemOnClick = ({
  displayLogo,
  ...rest
}: NavigationItemOnClick): ApiV2OnClick => rest;
